export default __webpack_public_path__ + "static/media/ic_plus_primary.25a54f93.svg";